import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  faCheckCircle,
  } from '@fortawesome/free-solid-svg-icons';
import { ModalController } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
  selector: 'app-successful-action',
  templateUrl: './successful-action.component.html',
  styleUrls: ['./successful-action.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class SuccessfulActionComponent implements OnInit {

  @Input() message: any;
  @Input() submessage: any;

  faCheckCircle = faCheckCircle;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {/* empty */}

  // manual close
  close() {
    try {
      this.modalCtrl.dismiss();
    } catch (e) {
      // failed to dismiss probably already happened
    }
  }

}
